import InfoModal from '@components/info-modal/InfoModal';
import InfoModalProvider from '@components/info-modal/InfoModalProvider';
import PgAvailabilityComponent from '@components/pg-availability-banner/PgAvailabilityComponent';
import { CollectionDataType } from '@ecosystem/newron-client-collections/build/shared/types';
import { BaseApiParams } from '@services/Types';
import { ProductGroupAvailability } from '@services/collection/Models';
import { getProductGroupAvailability } from '@services/collection/Availability.service';
import { removeYTDMATPeriodLabel } from '@utils/PeriodUtils';
import { FC, ReactNode, useEffect, useState } from 'react';

interface PgWarningBannerProps {
  baseApiParams: BaseApiParams;
  collectionDataType: CollectionDataType;
  children: ReactNode;
  requireAllPgLoadedInCollections?: boolean;
}

const PgWarningBanner: FC<PgWarningBannerProps> = ({
  baseApiParams,
  collectionDataType,
  children,
  requireAllPgLoadedInCollections,
}) => {
  return (
    <PgWarningBannerComponent
      baseApiParams={baseApiParams}
      collectionDataType={collectionDataType}
      requireAllPgLoadedInCollections={requireAllPgLoadedInCollections}
    >
      {children}
    </PgWarningBannerComponent>
  );
};

const PgWarningBannerComponent: FC<PgWarningBannerProps> = ({
  baseApiParams,
  collectionDataType,
  children,
  requireAllPgLoadedInCollections,
}) => {
  const [data, setData] = useState<ProductGroupAvailability>();

  useEffect(() => {
    const fetchProductGroupAvailability = async () => {
      const controller = new AbortController();

      try {
        const response = await getProductGroupAvailability(
          controller,
          baseApiParams,
          collectionDataType,
          requireAllPgLoadedInCollections,
        );
        setData(response);
      } catch (error) {
        console.error(error);
        setData(undefined);
      }
    };

    fetchProductGroupAvailability();
  }, []);

  const { period = '', availableProductGroups = [], unavailableProductGroups = [] } = data ?? {};
  const totalSubscriptionPgs = availableProductGroups.length + unavailableProductGroups.length;
  const totalAvailablePgs = availableProductGroups.length;

  return (
    <InfoModalProvider>
      <InfoModal />
      {data && (
        <PgAvailabilityComponent
          periodLabel={removeYTDMATPeriodLabel(period)!}
          totalAvailablePgs={totalAvailablePgs}
          totalSubscriptionPgs={totalSubscriptionPgs}
          unavailablePgs={unavailableProductGroups}
        />
      )}
      {children}
    </InfoModalProvider>
  );
};

export default PgWarningBanner;
